export const srcsetHelper = (imageUrl, width1x) =>
  `${imageUrl}?w=${width1x} 1x, ${imageUrl}?w=${width1x * 2} 2x, ${imageUrl}?w=${width1x * 3} 3x`;

export const getImageUrl = imageId => {
  // resolve image host based on environment
  const env = (window.zola && window.zola.env) || 'production';
  let hostname = '//images.zola.com';
  if (env === 'development') {
    // hostname = 'http://localhost:9100/v2/image'; // point directly at svc-image in development if pointing at development services
    hostname = '//stage-images.zola.com'; // use me if pointing services at stage (npm run dev-staging)
  } else if (env === 'staging') {
    hostname = '//stage-images.zola.com';
  }
  return `${hostname}/${imageId}`;
};



// WEBPACK FOOTER //
// ./src/cards/util/imageHelper.js